import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b728a76c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between mb-2 flex-wrap gap-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-color-secondary" }, "Hourly", -1))
const _hoisted_3 = {
  key: 0,
  class: "dash-empty"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-chart-timeline-variant dash-empty-icon" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No PPM hourly results for this period.", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_WSubTitle, { text: "Performance ratio — PR / APR / PPR" }),
      _hoisted_2
    ]),
    (!_ctx.hourly.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_apexchart, {
            type: "line",
            height: "280",
            options: _ctx.chartOptions,
            series: _ctx.chartSeries
          }, null, 8, ["options", "series"])
        ]))
  ]))
}